import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;

export default function Home() {
	return <Text>Welcome! Please select a tab above to view analytics.</Text>;
}
